import { Component } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [MaterialModule, RouterLink, RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: 'footer.component.scss'
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
